<template>
  <v-expansion-panel>
    <v-expansion-panel-header class="grey lighten-2">
      <span style="font-weight:bold;">Oxygen Cylinders</span>
    </v-expansion-panel-header>
    <v-expansion-panel-content>
      <v-card>
        <v-card-text>
          <span style="text-align:left;">{{ $t('step2_cylinder_size') }}</span>
          <span style="white-space:pre;"> (<a v-on:click="showoverlay_cylinder = true" style="color:#178ccb;">{{ $t('step1_unsure') }}</a>)</span>
          <supply-table-cylinder />
          <leakage v-model="leakage_cylinder_supply_only" />
          <v-divider style="margin-bottom: 1em; border-width: 2px 0 0 0;"/>
          <p class="caption">
            * {{ $t('step2_plant_footnote') }}
          </p>
        </v-card-text>
      </v-card>
    </v-expansion-panel-content>
  </v-expansion-panel>
</template>

<script>
import { mapFields } from 'vuex-map-fields';
import SupplyTableCylinder from '@/components/SupplyTableEditableCylinder.vue'
import Leakage from '@/components/Leakage.vue'

export default {
  name: 'Cylinder',

  components: {
    SupplyTableCylinder,
    Leakage
  },

  data: () => ({
    rules: {
      value: [
        val => {return val >= 0 || `Amount should be 0 or more`},
      ],
    },
  }),

  computed: {
    ...mapFields([
      'cylinder_types',
      'cylinder_type',
      'numtanks',
      'leakage_cylinder_supply_only',
      'showoverlay_cylinder'
    ]),
  }
}
</script>
